.Link {
  color: var(--color-default);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.5ch;
  font-size: 1.5rem;
  line-height: 1.5rem;
  flex: 0 0 auto;
}
.Link:hover {
  text-decoration: underline;
}

.Icon {
  color: var(--color-dim);
  flex: 0 0 1.5rem !important;
  width: 1.5rem !important;
  height: 1.5rem !important;
}

@media screen and (max-width: 500px) {
  .Label {
    display: none;
  }

  .Icon {
    color: var(--color-default);
    flex: 0 0 2rem !important;
    width: 2rem !important;
    height: 2rem !important;
  }
}
